import { render } from "./TradeQuoteHasExpired.vue?vue&type=template&id=5be21b22&scoped=true"
import script from "./TradeQuoteHasExpired.vue?vue&type=script&lang=js"
export * from "./TradeQuoteHasExpired.vue?vue&type=script&lang=js"

import "./TradeQuoteHasExpired.vue?vue&type=style&index=0&id=5be21b22&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be21b22"]])

export default __exports__